import { Component, Inject, computed, inject, signal } from '@angular/core';
import { MceSaveCancelComponent } from '../../components/mce-save-cancel/mce-save-cancel.component';
import { MceSaveCancelEvent } from '../../components/mce-save-cancel/mce-save-cancel.component';
import { MceSaveCancelConfig } from '../../components/mce-save-cancel/mce-save-cancel.component';
import { FormDirective } from '../../directives/form.directive';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatInputModule } from '@angular/material/input';

export enum InputDialogType { 'string', 'number' };
interface FormModel { value: string | number; }

@Component({
  selector: 'mce-input-dialog',
  imports: [MceSaveCancelComponent, FormDirective, FormsModule, ReactiveFormsModule,
    MatDialogModule, MatInputModule],
  templateUrl: './input.component.html',
  styleUrl: './input.component.scss'
})
export class InputDialogComponent {

  private dialogRef = inject(MatDialogRef<InputDialogComponent>);

  protected formValue = signal<FormModel>({ value: '' });

  protected formValid = signal<boolean>(false);
  protected formDirty = signal<boolean>(false);

  protected readonly viewModel = computed(() => {
    return {

      formValue: this.formValue(),
      formValid: this.formValid(),
      formDirty: this.formDirty(),

      showStringInput: this.data.type === InputDialogType.string,
      showNumberInput: this.data.type === InputDialogType.number,


      label: this.data.label,
      placeHolder: this.data.placeHolder,
      hintText: this.data.hintText,
      min: this.data.min ?? 1e-99,
      max: this.data.max ?? 1e99,

      enableOk: this.formValid() && this.formDirty(),

    };
  });

  protected get vm() { return this.viewModel(); }

  protected readonly saveCancelConfig = computed<MceSaveCancelConfig>(() => ({
    ok: { show: true, enable: this.vm.enableOk },
    cancel: { show: true, enable: true }
  }));

  onOkClick(): void {
   this.dialogRef.close(this.formValue().value);
  }

  onCancelClick(): void {
    this.dialogRef.close();
  }

  onSaveCancelAction(event: MceSaveCancelEvent): void {
    if (event.type === 'ok') {
      this.onOkClick();
      return;
    }

    if (event.type === 'cancel') {
      this.onCancelClick();
    }
  }

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: {
      type: InputDialogType,
      label: string,
      placeHolder: string,
      hintText?: string,
      initialValue?: string | number,
      min?: number;
      max?: number;
    }) {
    this.formValue.set({ value: data.initialValue ?? '' });
  }

  get type(): InputDialogType {
    console.log('type',this.data.type);
    return this.data.type;
  }


}
